import { memo } from 'react';
import { ChangeRepresentativeTemplate } from 'components/templates/ChangeRepresentativeTemplate';

type Props = {};

export const ChangeRepresentative = memo((_props: Props) => {
	return <ChangeRepresentativeTemplate />;
});
